export default __webpack_public_path__ + "static/media/Parallax-HUD-Radar.1d42da94.jpg";